import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  chip: {
    textTransform: 'uppercase',
    fontWeight: 500,
    minWidth: 120,
  },
  fullChip: {
    width: '100%',
  },
  pending: {
    backgroundColor: colors.blue[100],
    color: colors.blue[800],
  },
  replied: {
    backgroundColor: colors.indigo[100],
    color: colors.indigo[800],
  },
  overdue: {
    backgroundColor: colors.orange[100],
    color: colors.orange[800],
  },
  canceled: {
    backgroundColor: colors.red[100],
    color: colors.red[800],
  },
  finalized: {
    backgroundColor: colors.green[100],
    color: colors.green[800],
  },
  action: {
    padding: theme.spacing(1),
  },
}))

export default styles
